/** Every word the voice UI says, in the three languages. One status label per state; plain errors, never a code. */
const S = {
  en: {
    listening: 'Listening', hearing: 'Hearing you', thinking: 'Thinking', speaking: 'Speaking', muted: 'Muted',
    couldntHear: 'Couldn’t hear — tap to try again', connecting: 'Getting ready',
    mute: 'Mute', unmute: 'Unmute', stop: 'Stop', stopTalking: 'Stop talking', end: 'End', type: 'Type', interrupt: 'Tap to interrupt',
    buttonName: 'Voice. Tap for voice mode, or hold to record a message', holdName: 'Release to send',
    slideUp: 'Slide up to lock', slideCancel: 'Slide to cancel', releaseSend: 'Release to send', locked: 'Recording', send: 'Send', discard: 'Discard',
    tooShort: 'Hold a little longer', recording: 'Recording', hearingNow: 'Hearing you…', sendingNote: 'Sending…',
    errBlocked: 'The microphone is blocked — allow it in the browser to talk.',
    errHello: 'Please type your first question — after that I can hear you.',
    errLimit: 'Too many voice questions today — please type this one.',
    errFailed: 'I could not hear that — please try again or type it.',
    errUnsupported: 'Voice is not available in this browser — please type.',
    voiceMode: 'Voice mode', closeVoice: 'Close voice mode', typeInstead: 'Type instead',
    sendNow: 'Tap to send now', editHeard: 'Tap to fix what I heard', done: 'Done', cancel: 'Cancel',
    approveOnScreen: 'I put it on screen — tap Approve.', approveSaidYes: 'It is on screen — tap Approve.',
  },
  he: {
    listening: 'מקשיבה', hearing: 'שומעת אתכם', thinking: 'חושבת', speaking: 'מדברת', muted: 'המיקרופון מושתק',
    couldntHear: 'לא שמעתי — לחצו כדי לנסות שוב', connecting: 'מתכוננת',
    mute: 'השתקה', unmute: 'ביטול השתקה', stop: 'עצירה', stopTalking: 'עצירת הדיבור', end: 'סיום', type: 'הקלדה', interrupt: 'לחצו כדי להפסיק',
    buttonName: 'קול. לחיצה למצב קולי, או לחיצה ארוכה להקלטת הודעה', holdName: 'שחררו לשליחה',
    slideUp: 'החליקו למעלה לנעילה', slideCancel: 'החליקו לביטול', releaseSend: 'שחררו לשליחה', locked: 'מקליטה', send: 'שליחה', discard: 'מחיקה',
    tooShort: 'אפשר קצת יותר זמן', recording: 'מקליטה', hearingNow: 'שומעת אתכם…', sendingNote: 'שולחת…',
    errBlocked: 'המיקרופון חסום — אפשרו אותו בדפדפן כדי לדבר.',
    errHello: 'הקלידו את השאלה הראשונה — אחרי זה אוכל לשמוע אתכם.',
    errLimit: 'יותר מדי שאלות קוליות היום — הקלידו את זו.',
    errFailed: 'לא שמעתי את זה — נסו שוב או הקלידו.',
    errUnsupported: 'קול לא זמין בדפדפן הזה — הקלידו.',
    voiceMode: 'מצב קולי', closeVoice: 'סגירת מצב קולי', typeInstead: 'להקליד במקום',
    sendNow: 'לחצו כדי לשלוח עכשיו', editHeard: 'לחצו כדי לתקן את מה ששמעתי', done: 'סיום', cancel: 'ביטול',
    approveOnScreen: 'שמתי את זה על המסך — לחצו על אישור.', approveSaidYes: 'זה על המסך — לחצו על אישור.',
  },
  ar: {
    listening: 'أستمع', hearing: 'أسمعكم', thinking: 'أفكّر', speaking: 'أتحدّث', muted: 'الميكروفون مكتوم',
    couldntHear: 'لم أسمع — اضغطوا للمحاولة من جديد', connecting: 'أتحضّر',
    mute: 'كتم', unmute: 'إلغاء الكتم', stop: 'إيقاف', stopTalking: 'إيقاف الكلام', end: 'إنهاء', type: 'كتابة', interrupt: 'اضغطوا للإيقاف',
    buttonName: 'الصوت. اضغطوا للوضع الصوتي، أو اضغطوا مطوّلاً لتسجيل رسالة', holdName: 'أفلتوا للإرسال',
    slideUp: 'اسحبوا لأعلى للقفل', slideCancel: 'اسحبوا للإلغاء', releaseSend: 'أفلتوا للإرسال', locked: 'تسجيل', send: 'إرسال', discard: 'حذف',
    tooShort: 'اضغطوا لوقت أطول قليلاً', recording: 'تسجيل', hearingNow: 'أسمعكم…', sendingNote: 'جارٍ الإرسال…',
    errBlocked: 'الميكروفون محظور — اسمحوا به في المتصفح للتحدث.',
    errHello: 'اكتبوا سؤالكم الأول — بعدها أستطيع أن أسمعكم.',
    errLimit: 'أسئلة صوتية كثيرة اليوم — اكتبوا هذا السؤال.',
    errFailed: 'لم أسمع ذلك — حاولوا مرة أخرى أو اكتبوه.',
    errUnsupported: 'الصوت غير متاح في هذا المتصفح — اكتبوا.',
    voiceMode: 'الوضع الصوتي', closeVoice: 'إغلاق الوضع الصوتي', typeInstead: 'اكتبوا بدلاً من ذلك',
    sendNow: 'اضغطوا للإرسال الآن', editHeard: 'اضغطوا لتصحيح ما سمعته', done: 'تم', cancel: 'إلغاء',
    approveOnScreen: 'وضعته على الشاشة — اضغطوا موافقة.', approveSaidYes: 'هو على الشاشة — اضغطوا موافقة.',
  },
};

export const voiceLanguage = (lang) => { const l = String(lang || 'en').split('-')[0].toLowerCase(); return l === 'he' || l === 'iw' ? 'he' : l === 'ar' ? 'ar' : 'en'; };
export const voiceText = (lang, key) => (S[voiceLanguage(lang)] || S.en)[key] ?? S.en[key] ?? key;
export const isRtlVoice = (lang) => voiceLanguage(lang) !== 'en';

/** The plain sentence for an ears error code. */
export function errorText(lang, code) {
  const key = { 'mic-blocked': 'errBlocked', hello: 'errHello', limit: 'errLimit', unsupported: 'errUnsupported' }[code] || 'errFailed';
  return voiceText(lang, key);
}
